var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml"},[_c('LogoTextH',{staticStyle:{"width":"6rem"}}),_vm._v(" "),_c('h1',{staticClass:"text-small text-uppercase my-0"},[_vm._v("Manual de Marca")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }